import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import styles from './PersonalAreaController.module.sass'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import FuseHighlight from 'components/FuseHighlight/FuseHighlight'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const NotesRow = (props) => {
	const { noteItem, contentUri, isNotesTab } = props
	const { note, processId, author, reminderDate } = noteItem
	const { deleteNote, updateNote, i18n } = useGlobal()

	const notesOptions = [
		{
			value: 'update',
			text: isNotesTab ? i18n`Update note` : i18n`Update reminder`,
			action: () =>
				updateNote &&
				updateNote({
					note: noteItem,
					processId,
					contentUri,
				}),
		},
		{
			value: 'delete',
			text: isNotesTab ? i18n`Delete note` : i18n`Delete reminder`,
			action: () =>
				deleteNote &&
				deleteNote({
					note: noteItem,
					processId,
					contentUri,
				}),
		},
	]

	return (
		<HStack className={styles['reminder-row']} justify='space-between'>
			<HStack className={styles['reminder-row-left']} gap='xsmall'>
				<Tooltip text={author?.name || ''}>
					<div className={styles['avatar-container']}>
						<Avatar
							rounded
							className={styles['avatar']}
							user={author}
						/>
					</div>
				</Tooltip>

				<Tooltip text={note}>
					<div className={styles['reminder-note']}>
						<FuseHighlight
							className={styles['reminder-note']}
							matchedWords={
								noteItem.$textHighlight?.matchedIndexes?.[
									'note'
								]
							}
							text={note}
						/>
					</div>
				</Tooltip>
			</HStack>

			<div className={styles['reminder-row-right']}>
				<div className={styles['note-secondary-info']}>
					{processId && (
						<Link
							to={`/clinical-processes/${processId}/appointments`}
						>
							<small>
								#
								<FuseHighlight
									className={styles['reminder-note']}
									matchedWords={
										noteItem.$textHighlight
											?.matchedIndexes?.['processId']
									}
									text={`${processId}`}
								/>
							</small>
						</Link>
					)}
				</div>

				<div className={styles['note-secondary-info']}>
					{reminderDate?.shortDateFormat && (
						<span>
							<small>{reminderDate?.shortDateFormat}</small>
						</span>
					)}
				</div>
				<ModalOptions
					options={notesOptions}
					title={i18n`Options`}
					onSelect={(item) => {
						item && item.action && item.action()
					}}
				>
					<ActionButton
						className={styles['action-button']}
						icon='options'
					/>
				</ModalOptions>
			</div>
		</HStack>
	)
}

export default NotesRow
